import _ from "lodash";

export {
    extractCollectionsList,
    processMetaLine,
    processMetaLineTypeChange,
}

const extractCollectionsList = (productsList) => {
    let collectionsMap = {};

    _.forEach(productsList, (product, index) => {
        _.forEach(product.collections, (collection, index) => {
            collectionsMap[collection.id] = collection;
        });
    });

    return _.values(collectionsMap);
}

const processMetaLine = (metaLine) => {
    if (metaLine.metaType === 'seoTitle') {
        metaLine.metaLabel = 'Meta Title';
    } else if (metaLine.metaType === 'seoDescription') {
        metaLine.metaLabel = 'Meta Description';
    } else if (metaLine.metaType === 'excerpt') {
        metaLine.metaLabel = 'Excerpt';
    }

    if (metaLine.metaType) {
        metaLine.newType = metaLine.metaType;
        metaLine.isMeta = true;
    }
}

const processMetaLineTypeChange = (metaLine, newType) => {
    metaLine.metaType = newType;
    metaLine.newType = newType;
    metaLine.isMeta = true;

    if (metaLine.text.indexOf(':') > -1) {
        const splitText = metaLine.text.split(':');
        metaLine.text = splitText[1];
    }

    processMetaLine(metaLine);
}
